import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  DETAIL: '/dh-datamaint/specimen/getSpecInfoById',
  MARK_LIST: '/dh-datamaint/mark/listMarkTree',
  RELATED_SPEC_LIST: '/dh-datamaint/specimen/listRelatedSpecById',
  RELATED_LIST: '/dh-datamaint/specimen/getRelatedResById',
  ADD_MARK: '/dh-datamaint/mark/addMark',
  UPDATE_MARK: '/dh-datamaint/mark/updateMark',
  MARK_DETAIL: '/dh-datamaint/mark/getById',
  ADD_MARK_GROUP: '/dh-datamaint/mark/addMarkGroup',
  UPDATE_MARK_GROUP: '/dh-datamaint/mark/updateMarkGroup',
  SORT_MARK: '/dh-datamaint/mark/sort'
};

class SpecDetailModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL,
        {
          headers: { secondLang: payload.data.lang },
          params: payload.data
        });
    },

    async getMarkList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.MARK_LIST, {
        headers: { secondLang: payload.data.lang },
        params: payload.data
      });
    },

    async getRelatedList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATED_LIST, {
        headers: { secondLang: payload.data.lang },
        params: payload.data
      });
    },

    async addMark(context: ActionContext<any, any>, data: any) {
      await ajax.post(URL.ADD_MARK, data);
    },

    async updateMark(context: ActionContext<any, any>, data: any) {
      await ajax.post(URL.UPDATE_MARK, data);
    },

    async getMarkDetail(context: ActionContext<any, any>, data: any) {
      return await ajax.get(URL.MARK_DETAIL, { params: data });
    },

    async addGroup(context: ActionContext<any, any>, data: any) {
      await ajax.post(URL.ADD_MARK_GROUP, data);
    },

    async updateGroup(context: ActionContext<any, any>, data: any) {
      await ajax.post(URL.UPDATE_MARK_GROUP, data);
    },

    async sortMark(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT_MARK, payload.data);
    }
  };
}

export const specDetailModule = new SpecDetailModule();
